module.exports = __webpack_public_path__ + "static/media/internacional.02c98b4a.svg";